module.exports = __webpack_public_path__ + "img/بدون-عکس.8138fe56.jpg";